<template>
  <main>
    <app-banner :num="(num_rows) ? num_rows : 0"></app-banner>
    <section class="row-3" v-if="matchs && matchs.length === 0">
      <p class="text-info">
        Aucun match enregistré dans le système !<br>
        <button v-b-modal.modal-ajouter-matchs class="mt-2 btn btn-outline-info">Ajouter</button>
      </p>
    </section>
    <section v-if="matchs && matchs.length !== 0" class="d-flex flex-row flex-wrap justify-content-between row-2">
      <div class="w-40 input-group flex-nowrap column-left">
        <input type="text" class="form-control" placeholder="Rechercher..." aria-label="Username" aria-describedby="addon-wrapping">
        <div class="input-group-prepend">
            <span class="input-group-text" id="addon-wrapping">
              <font-awesome-icon :icon="['fas', 'search']"></font-awesome-icon>
            </span>
        </div>
      </div>
      <div class="column-right">
        <button class="btn">
          <font-awesome-icon :icon="['fas', 'sort']"></font-awesome-icon>
          <span>A-Z</span>
        </button>
        <button class="btn">
          <font-awesome-icon :icon="['fas', 'sort']"></font-awesome-icon>
          <span>Date</span>
        </button>
      </div>
    </section>
    <hr>
    <section v-if="matchs && matchs.length !== 0" class="row-3">
      <ul class="list-group">
        <li class="list-group-item active d-flex flex-row justify-content-between">
          <div>NOMS</div>
          <div>OPTIONS</div>
        </li>
        <li :key="match.match_id.slice(5,10)"
            v-for="(match, idx) in matchs">
          <div class="d-flex flex-row flex-wrap flex-md-nowrap justify-content-between list-group-item">
            <div class="w-100 w-md-50 text-center text-md-left">
              <span>{{ (equipes) ? equipes.filter( (equipe) => equipe.equipe_id === match.equipe_a_id )[0].nom.toUpperCase() : '' }}</span>
              <b>vs</b>
              <span>{{ (equipes) ? equipes.filter( (equipe) => equipe.equipe_id === match.equipe_b_id )[0].nom.toUpperCase() : '' }}</span>
              (<b class="text-nowrap">{{ new Date(match.date_rencontre).toLocaleDateString() }} - {{ match.temps_rencontre }}</b>)
              (<em class="text-nowrap">{{ returnJourney(match.journee) }}</em>)
            </div>
            <div class="mt-2 mt-md-0 w-100 w-md-30 d-flex flex-row justify-content-around">
              <div class="div-icon-read" v-b-toggle="'collapse' + idx" @click="selectedComponent = 'AppRead'">
                <font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon>
              </div>
              <div class="div-icon-update" v-b-toggle="'collapse' + idx" @click="selectedComponent = 'AppUpdate'">
                <font-awesome-icon :icon="['fas', 'pen']"></font-awesome-icon>
              </div>
              <div class="div-icon-delete" v-b-toggle="'collapse' + idx" @click="selectedComponent = 'AppDelete'">
                <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
              </div>
            </div>
          </div>
          <b-collapse :id="'collapse' + idx" class="list-group-item">
            <keep-alive>
              <component :is="selectedComponent" :match="match"></component>
            </keep-alive>
          </b-collapse>
        </li>
      </ul>
    </section>
    <aside v-if="(num_rows && num_rows > dataForm.pageNum)" class="text-white bg-color-light-golden-orange text-center">
      {{ currentIndex }} / {{ Math.ceil(num_rows / dataForm.pageNum) }}
    </aside>
    <section v-if="(num_rows && num_rows > dataForm.pageNum)" class="d-flex flex-row justify-content-center row-4">
      <nav aria-label="Page navigation">
        <ul class="pagination">
          <li class="page-item cursor-pointer" @click="previous()">
            <a :class="(dataForm.pageIdx - dataForm.pageNum < 0) ? 'page-link pagination-disabled' : 'page-link'">Précédent</a>
          </li>
          <li class="page-item cursor-pointer" @click="next()">
            <a :class="(dataForm.pageIdx + dataForm.pageNum > num_rows) ? 'page-link pagination-disabled' : 'page-link'">Suivant</a>
          </li>
        </ul>
      </nav>
    </section>
  </main>
</template>

<script>
import Read from "./components/Read";
import Update from "./components/Update";
import Delete from "./components/Delete";
import Banner from "../shared/Banner";
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: "Matchs",
  props: {},
  data(){
    return{
      equipes: null,
      matchs: null,
      selectedComponent: 'AppRead',
      num_rows: '',
      currentIndex: 1,
      error: '',
      dataForm: {
        table: 'matchs_non_joues',
        pageIdx: 0,
        pageNum: 10,
      }
    }
  },
  components: {
    AppRead: Read,
    AppUpdate: Update,
    AppDelete: Delete,
    AppBanner: Banner
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosGetPaginatedData',
      'axiosGetNumRows',
    ]),
    returnJourney(journee) {
      return (parseInt(journee) === 1) ? (journee + 'ère journée') : (journee + 'ème journée')
    },
    previous(){
      if(!(this.dataForm.pageIdx - this.dataForm.pageNum < 0)){
        this.dataForm.pageIdx -= this.dataForm.pageNum
        this.currentIndex--
      }
      //
      this.axiosGetPaginatedData(this.dataForm)
          .then((data) => {
            this.matchs = data.data
          })
          .catch((data) => {
            this.matchs = data
          })
    },
    next(){
      if(!(this.dataForm.pageIdx + this.dataForm.pageNum > this.num_rows)){
        this.dataForm.pageIdx += this.dataForm.pageNum
        this.currentIndex++
      }
      //
      this.axiosGetPaginatedData(this.dataForm)
          .then((data) => {
            this.matchs = data.data
          })
          .catch((data) => {
            this.matchs = data
          })
    },
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {},
  created() {
    //
    this.axiosGetNumRows(this.dataForm)
        .then((data) => this.num_rows = parseInt(data.data[0][0]))
        .catch((error) => this.error = error)
    //
    this.axiosGetPaginatedData(this.dataForm)
        .then((data) => {
          this.matchs = data.data
        })
        .catch((data) => {
          this.matchs = data
        })
    //
    this.axiosGetAllData({
      table: "equipes"
    })
        .then((data) => {
          this.equipes = data.data
        })
        .catch((data) => {
          this.equipes = data
        })
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
@import "../../../src/assets/css/customized/main_right";
</style>



// WEBPACK FOOTER //
// src/components/matchs/Matchs.vue